"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgGasCan48 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 .5h48v48H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M30.75 20.75 19.5 32m0-11.25L30.75 32M27 12.5h4.5a.75.75 0 1 1 0 1.5H27a.75.75 0 1 1 0-1.5Zm-7.434 1.503A900 900 0 0 1 21.69 14c.702 0 1.905-.99 3.61-2.97a2.949 2.949 0 0 1 1.995-.78h4.237c1.64 0 2.968 1.344 2.968 3.002v22.496c0 1.608-1.25 2.92-2.82 2.998l-.166.004-13.565-.087C16.317 38.653 15 37.31 15 35.66V18.315l4.566-4.312Zm-4.355 3.745-1.711-1.82 3.663-3.417 1.712 1.82", stroke: "currentColor" })] })) }))); };
exports.default = SvgGasCan48;
